<h1 class="headline-1-bold" matDialogTitle>{{data.title}}</h1>
<div [innerHTML]="data.text" mat-dialog-content #text></div>
<div mat-dialog-actions>
    <button (click)="copyText(text.textContent)"  color="accent" mat-stroked-button>
        Copy
    </button>
    <button (click)="closeDialog(true)" color="accent" mat-raised-button>
        Close
    </button>
</div>